import React, { useRef, useState, useEffect } from "react";
import "./CommunityDetail.css";
import UploadFile from "../../../../assets/images/UploadFile.svg";
import editIcon from "../../../../assets/images/edit.svg";
import CopyIcon from "../../../../assets/images/Copy.svg";
import FloatingTextFiled from "../../CommonComponents/FloatingTextFiled/FloatingTextFiled";
import { useDispatch, useSelector } from "react-redux";
import useApi from "../../../../helpers/apiHelper/requestHelper";
import { toastify } from "../../../../helpers/toast/toastify";
import {
  setRefetchMultiCommunityList,
  setRefetchSpecificUser,
  setRefetchPage,
} from "../../../../redux/multicommunity/multicommunity";
import BubbleSvgButton from "../../CommonComponents/BubbleSvgButton/BubbleSvgButton";
import { toast } from "react-toastify";
import useImageUpload from "../../../../hooks/useImageUpload";
import ImageUploadModals from "../../../../components/ImageUploadModals/ImageUploadModals";

const CommunityDetail = () => {
  const api = useApi();
  const dispatch = useDispatch();
  const [communityName, setCommunityName] = useState("");
  const [originalCommunityName, setOriginalCommunityName] = useState(""); // Store original name
  const [editableField, setEditableField] = useState(null);
  const [showButton, setShowButton] = useState(false);
  const [communityLogo, setCommunityLogo] = useState("");
  const selectedCommunity = useSelector(
    (state) => state?.multiCommunity?.currentCommunity
  );
  const user = useSelector((state) => state?.user?.user);

  const inputRefs = useRef({});
  const communityDetailRef = useRef(null); // Reference to the main container

  // Use the centralized image upload hook
  const {
    fileInputRef,
    imageSrc,
    showCropper,
    editor,
    scale,
    fileName,
    showEditChoiceModal,
    // isProgrammaticUpload,
    setEditor,
    setScale,
    // setFileName,
    setIsProgrammaticUpload,
    setShowEditChoiceModal,
    handleFileChange,
    handleIconClick,
    handleEditChoice,
    handleCropSave,
    handleCropCancel,
  } = useImageUpload(selectedCommunity);

  // Handle click outside functionality
  useEffect(() => {
    const handleClickOutside = (event) => {
      console.log("Click detected", { editableField, target: event.target });
      
      if (editableField === "communityName") {
        // Check if click is outside the editable field container
        const editableFieldContainer = event.target.closest('.editable-field');
        const saveButtonContainer = event.target.closest('.submitbtn');
        
        // If click is not within the editable field or save button
        if (!editableFieldContainer && !saveButtonContainer) {
          console.log("Clicking outside - resetting field");
          // Reset to original name and deactivate field
          setCommunityName(originalCommunityName);
          setEditableField(null);
          setShowButton(false);
        }
      }
    };

    if (editableField === "communityName") {
      document.addEventListener('click', handleClickOutside);
    }
    
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [editableField, originalCommunityName]);

  const handleEditClick = (fieldId) => {
    setEditableField(fieldId);

    setTimeout(() => {
      if (inputRefs.current[fieldId]) inputRefs.current[fieldId].focus();
    }, 100);
  };

  useEffect(() => {    
    if (selectedCommunity) {
      setCommunityName(selectedCommunity?.disPlayName);
      setOriginalCommunityName(selectedCommunity?.disPlayName); // Store original name
      setCommunityLogo(selectedCommunity?.logo || "");
    }
  }, [selectedCommunity]);

  const handleSave = async () => {
    try {
      if (selectedCommunity?.disPlayName !== communityName) {
        if (!communityName) {
          toastify("Community required");
          return;
        }
        if (communityName?.length > 30) {
          toastify("Community Name must not be greated than 30 character");
          return;
        }

        const response = await api(
          "post",
          "multiCommunity/updateCommunityName",
          {
            communityName: communityName,
          }
        );

        if (response?.status) {
          setEditableField(null);
          setOriginalCommunityName(communityName); // Update original name after successful save
          dispatch(setRefetchSpecificUser(true));
          dispatch(setRefetchMultiCommunityList(true));
          dispatch(setRefetchPage("Settings"));
          toastify("Community name is changed", "success");
          setShowButton(false);
        } else {
          setEditableField(null);
          toastify(response?.message, "error");
        }
      } else {
        setEditableField(null);
        setShowButton(false);
        toastify("please change community name", "error");
      }
    } catch (error) {
      toastify(error?.message, "error");
      setShowButton(false);
      setEditableField(null);
    }
  };

  return (
    <>
      <div className="communityDetailBox" ref={communityDetailRef}>
        <div className="headingBox">
          <h2 className="title">Community Details</h2>
        </div>
        <div className="InputsRow">
          <div className="editable-field fixedWidth1440-298 editableSettingsFields">
            <FloatingTextFiled
              className={editableField !== "communityName" ? "accdetailinputbox" : "accdetailinputbox-active"}
              forLabel="community-name"
              id="community-name"
              label="Community Name"
              placeholder="Community Name"
              type="text"
              value={
                !user?.leaderCommunity && !user?.tradeName
                  ? "YourCommunityNameWillShowHere"
                  : communityName
              }
              ref={(el) => (inputRefs.current["communityName"] = el)}
              disabled={editableField !== "communityName"}
              onChange={(e) => {
                setShowButton(true);
                setCommunityName(e.target.value);
              }}
              focusedAllowed={false}
              maxLength={30}
            />
            <span
              className="edit-icon"
              style={{ cursor: "pointer", marginLeft: "10px", opacity: 1 }}
              onClick={() => handleEditClick("communityName")}
            >
              <img alt="Edit Icon" src={editIcon} style={{ width: "14px", height: "14px" }} />
            </span>
          </div>
          <div className="editable-field fixedWidth1440-298 editableSettingsFields">
            <FloatingTextFiled
              className="accdetailinputbox"
              forLabel="community-name"
              id="community-name"
              label="Copy Trading URL"
              placeholder="Copy Trading URL"
              type="text"
              disabled={true}
              focusedAllowed={false}
              value={
                !user?.leaderCommunity && !user?.tradeName
                  ? "YourUniqueURLWillShowHere"
                  : `${document.location.origin.replace(
                      document.location.pathname,
                      ""
                    )}/community/${selectedCommunity?.name?.split(" ").join("")}`
              }
            />
            <span
              className="edit-icon"
              style={{ cursor: "pointer", marginLeft: "10px", opacity: 1 }}
            >
              <img
                alt="Copy Icon"
                src={CopyIcon}
                onClick={() => {
                  // Construct the community link using template literals
                  const communityLink = `${document.location.origin.replace(
                    document.location.pathname,
                    ""
                  )}/community/${selectedCommunity?.name?.split(" ").join("")}`;

                  // Attempt to copy the link to the clipboard
                  navigator.clipboard
                    .writeText(communityLink)
                    .then(() => {
                      const toastId = 123;

                      if (!toast.isActive(toastId)) {
                        console.log(toast.isActive(toastId), "this is a toast id to check it si appearing or not")
                        toast.success("Community link copied to clipboard!", {
                          id: toastId,
                          autoClose: 1000,
                          position: "top-center",
                          hideProgressBar: true,
                          closeOnClick: true,
                          pauseOnHover: true,
                          draggable: true,
                          className: "toast-message",
                        });
                      }

                      // // Success: Show a toast notification
                      // toastify(
                      //   "Community link copied to clipboard!",
                      //   "success"
                      // );

                    })
                    .catch((error) => {
                      // Error: Handle clipboard write failure and show a toast notification
                      console.error("Clipboard write error:", error);
                      toastify(
                        "Failed to copy community link to clipboard.",
                        "error"
                      );
                    });
                }}
                style={{ width: "14px", height: "14px" }}
              />
            </span>
          </div>

          <div
            className="editable-field fixedWidth1440-298 uploadPhotoField"
            style={{ display: "flex", alignItems: "center", cursor: "pointer" }}
            onClick={() => {
              setIsProgrammaticUpload(false);
              handleIconClick();
            }}
          >
            {/* Old custom upload field:
            <div className="accdetailinputbox DisableOvercome uploadFileInputWrap">
              <div className="position-relative">
                <label>Upload Photo</label>
                <p className="uplaodFileText updatedTextField" style={{color:"black"}}>
                  {fileName ? fileName : `${communityLogo ? "Change" : "Upload"}  community photo (logo)`}
                </p>
              </div>
            </div>
            */}
            <FloatingTextFiled
              className="accdetailinputbox"
              label="Upload Photo"
              value={fileName || (communityLogo ? "Change community photo (logo)" : "Upload community photo (logo)")}
              disabled={true}
              focusedAllowed={false}
            />
            <span
              className="edit-icon UploadFileImg"
              style={{ cursor: "pointer", marginLeft: "10px", opacity: 1 }}
            >
              <img alt="Upload Icon" src={UploadFile} style={{ width: "18px", height: "18px" }} />
            </span>

            <input
              type="file"
              ref={fileInputRef}
              onChange={handleFileChange}
              accept="image/jpeg,image/jpg,image/png,image/gif"
              style={{ display: "none" }}
            />
          </div>
        </div>

        {showButton && (
          <div className="submitbtn ms-lg-auto ms-md-auto mt-4">
            <BubbleSvgButton
              className="communityDetailBtn"
              onClick={handleSave}
              text={"Save edits"}
              type="button"
              variant="green"
              containerStyling={{
                justifyContent: "center",
                padding: 0,
              }}
            />
          </div>
        )}
      </div>

      {/* Image Upload Modals */}
      <ImageUploadModals
        showCropper={showCropper}
        imageSrc={imageSrc}
        editor={editor}
        setEditor={setEditor}
        scale={scale}
        setScale={setScale}
        handleCropSave={handleCropSave}
        handleCropCancel={handleCropCancel}
        communityName={communityName}
        showEditChoiceModal={showEditChoiceModal}
        setShowEditChoiceModal={setShowEditChoiceModal}
        handleEditChoice={handleEditChoice}
        fileInputRef={fileInputRef}
        setIsProgrammaticUpload={setIsProgrammaticUpload}
      />
    </>
  );
};

export default CommunityDetail;
